import { ChangeDetectionStrategy, Component, computed, input, output, Signal } from '@angular/core';
import { IconModule } from '@shared/modules/common/icon/icon.module';
import { AtomModule } from '@shared/modules/color-scheme/atom/atom.module';
import { LinkModule } from '@shared/ui/kit/link/link.module';
import { AtomType } from '@shared/modules/color-scheme/common/atom-type';
import { getStatusAtom, getStatusIconNameForStatus } from '@shared/ui/status/status';
import { ToastItem } from '@shared/ui/kit/toast/toast-item';

@Component({
  selector: 'loop-toast-card',
  templateUrl: './toast-card.component.html',
  styleUrls: ['./toast-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconModule, AtomModule, LinkModule]
})
export class ToastCardComponent {
  readonly toastSignal = input.required<ToastItem>({ alias: 'toast' });
  /** The user clicked the close cross; the stack owns removal. */
  readonly closed = output<void>();

  protected readonly statusAtom: Signal<AtomType> = computed(() => getStatusAtom(this.toastSignal().kind));
  protected readonly statusIconName: Signal<string> = computed(() =>
    getStatusIconNameForStatus(this.toastSignal().kind)
  );
}
